<template>
  <div class="search_event">
    <div class="search_event_left">
      <div class="search_event_line_up">
        <a class="search_event_icon" :href="tournament['extra_data']['event_view_url']">
          <img :src="tournament['extra_data']['event_card_image']" @error="replaceByAvatarDefault">
          <div v-show="tournament['extra_data']['event_is_paid'] || parseInt(tournament['extra_data']['event_prize_pool']) > 0" class="search_event_prize_pool">${{ tournament['extra_data']['event_prize_pool'] }} <div class="search_event_prize_pool_text">prize pool</div></div>
        </a>
        <div class="search_event_info">
          <a :href="tournament['extra_data']['event_view_url']">
            <div class="search_event_title">
              {{ tournament['extra_data']['event_title'] }}
            </div>
          </a>
          <div class="search_event_desc">{{ tournament['extra_data']['event_description'] }}</div>
          <div class="search_event_about">
            <a class="search_event_social" target="_blank" :href="tournament['extra_data']['event_link_discord']">
              <img :src="contentCloudFront('/assets/v4/codered/discord.png')">
              Join the Discord
            </a>
            <a class="search_event_social" target="_blank" :href="tournament['extra_data']['event_link_share_twitter']">
              <img :src="contentCloudFront('/assets/v4/codered/chain.png')">
              Share the event
            </a>
            <a class="search_event_social" target="_blank" :href="tournament['extra_data']['event_link_rule']">
              <img v-if="appConfig.isAvglDomain" :src="contentCloudFront('/assets/v4/codered/RulesIconRed.png')">
              <img v-else :src="contentCloudFront('/assets/v4/codered/RulesIcon.png')">
              Rules
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="search_event_right">
      <div :class="'search_event_detail search_event_action' + (tournament['extra_data']['event_is_paid'] ? ' event_required_paid' : '')">
        <div class="search_event_date">
          <event-calendar-icon name="event-calendar" />
          <span>{{ tournament['extra_data']['event_date'] }}</span>
        </div>
        <div class="search_event_time">
          <event-clock-icon name="event-clock" />
          <span>{{ tournament['extra_data']['event_time'] }}</span>
        </div>
        <div class="search_event_type_team">
          <event-detail-icon name="event-detail" />
          <span>{{ tournament['extra_data']['event_game_display_name'] }}, {{ tournament['extra_data']['event_type_display'] }} {{ tournament['extra_data']['event_team_size_display'] }}</span>
        </div>
        <div v-show="tournament['extra_data']['event_is_paid']" class="search_entry_fee">${{ tournament['extra_data']['event_entry_fee_formated'] }} <div class="search_entry_fee_text">entry fee</div></div>
        <template v-if="!tournament['extra_data']['event_is_codered']">
          <a class="landing_btn search_event_tournament" :href="tournament['extra_data']['event_view_my_team_url']">
            <span v-if="tournament['extra_data']['event_ended'] || tournament.not_allow_registration || tournament.participant === 3">View Event</span>
            <template v-else>
              <span v-if="tournament.register_email_sent">Pending Email</span>
              <template v-else>
                <span v-if="tournament.is_in_person">How To Participate</span>
                <span v-else>Register Now</span>
              </template>
            </template>
          </a>
        </template>
        <template v-else>
          <div v-if="tournament['extra_data']['event_allow_register']" class="search_event_action_register">
            <div class="search_event_action_register">
              <div class="qualifier_codered_event_action">
                <a class="landing_btn search_event_tournament" :href="tournament['extra_data']['event_view_my_team_url']">
                  <span v-if="tournament.status !== 0 || tournament.not_allow_registration || tournament.participant === 3">View Event</span>
                  <span v-else>Register Now</span>
                </a>
              </div>
            </div>
          </div>
          <a v-else class="landing_btn search_event_tournament" :href="tournament['extra_data']['event_view_my_team_url']">
            <span>Invite Friends</span>
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { component } from '../../mixins/component';
import EventCalendarIcon from '../../components/shared/icons/index.vue';
import EventClockIcon from '../../components/shared/icons/index.vue';
import EventDetailIcon from '../../components/shared/icons/index.vue';

export default {
  components: { EventCalendarIcon, EventClockIcon, EventDetailIcon },
  mixins: [component],
  props: {
    tournament: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {

    };
  },
  created() {

  },
  methods: {

  },
};
</script>
